import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "xmlns:dc": "http://purl.org/dc/elements/1.1/",
  "xmlns:cc": "http://creativecommons.org/ns#",
  "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
  "xmlns:svg": "http://www.w3.org/2000/svg",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
  "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
  "inkscape:version": "0.92.4 (5da689c313, 2019-01-14)",
  "sodipodi:docname": "Zoom_2011.svg",
  id: "svg835",
  version: "1.1",
  viewBox: "0 0 1000 224.72337"
}
const _hoisted_2 = { id: "metadata841" }

export function render(_ctx, _cache) {
  const _component_dc58format = _resolveComponent("dc:format")
  const _component_dc58type = _resolveComponent("dc:type")
  const _component_dc58title = _resolveComponent("dc:title")
  const _component_cc58Work = _resolveComponent("cc:Work")
  const _component_rdf58RDF = _resolveComponent("rdf:RDF")
  const _component_sodipodi58namedview = _resolveComponent("sodipodi:namedview")

  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("metadata", _hoisted_2, [
      _createVNode(_component_rdf58RDF, null, {
        default: _withCtx(() => [
          _createVNode(_component_cc58Work, { "rdf:about": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_dc58format, null, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("image/svg+xml", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_dc58type, { "rdf:resource": "http://purl.org/dc/dcmitype/StillImage" }),
              _createVNode(_component_dc58title)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("defs", { id: "defs839" }, null, -1)),
    _createVNode(_component_sodipodi58namedview, {
      "inkscape:current-layer": "svg835",
      "inkscape:window-maximized": "1",
      "inkscape:window-y": "-8",
      "inkscape:window-x": "1912",
      "inkscape:cy": "-314.24417",
      "inkscape:cx": "948.1979",
      "inkscape:zoom": "0.49497475",
      showgrid: "false",
      id: "namedview837",
      "inkscape:window-height": "1017",
      "inkscape:window-width": "1920",
      "inkscape:pageshadow": "2",
      "inkscape:pageopacity": "0",
      guidetolerance: "10",
      gridtolerance: "10",
      objecttolerance: "10",
      borderopacity: "1",
      "inkscape:document-rotation": "0",
      bordercolor: "#666666",
      pagecolor: "#ffffff",
      "fit-margin-top": "0",
      "fit-margin-left": "0",
      "fit-margin-right": "0",
      "fit-margin-bottom": "0"
    }),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      "inkscape:connector-curvature": "0",
      id: "path833",
      d: "m 814.1856,67.388717 c 3.82247,6.59494 5.07303,14.0983 5.48595,22.53368 l 0.5427,11.243253 v 78.62013 l 0.55449,11.25504 c 1.10899,18.38088 14.66459,31.97188 33.18704,33.12806 l 11.19606,0.55449 V 101.16565 l 0.55449,-11.243253 c 0.46011,-8.341 1.69888,-15.98593 5.58033,-22.62806 a 44.902197,44.902197 0 0 1 77.74711,0.14157 c 3.82246,6.59494 5.01403,14.23987 5.47415,22.48649 l 0.55449,11.207863 v 78.65552 l 0.55449,11.25504 c 1.15618,18.47526 14.60561,32.06626 33.18705,33.12806 L 1000,224.72337 V 89.922397 A 89.898775,89.898775 0 0 0 910.13662,0.02362708 89.662821,89.662821 0 0 0 842.71254,30.473587 89.780798,89.780798 0 0 0 775.28845,0.01182708 c -18.66402,0 -35.9831,5.66292002 -50.32915,15.44323992 C 716.20538,5.6865371 696.62113,0.01182708 685.37788,0.01182708 V 224.72337 l 11.24325,-0.55449 c 18.80559,-1.23877 32.39659,-14.46403 33.12805,-33.12806 l 0.60168,-11.25504 v -78.62013 l 0.5545,-11.243253 c 0.47191,-8.48257 1.65168,-15.93874 5.48595,-22.58087 a 45.020174,45.020174 0 0 1 38.89714,-22.39211 44.949388,44.949388 0 0 1 38.89715,22.4393 z M 44.93759,224.18067 l 11.243246,0.5427 H 224.71155 l -0.5545,-11.20785 c -1.52191,-18.47526 -14.6056,-31.97188 -33.13985,-33.17525 l -11.24324,-0.55449 H 78.667327 L 213.4683,44.937617 212.91381,33.741567 C 212.04077,15.077537 198.40259,1.5927271 179.77396,0.56631708 l -11.24325,-0.5073 L 0,0.01182708 0.55449376,11.255077 C 2.0292112,29.553367 15.301668,43.333127 33.682546,44.394927 l 11.255044,0.55449 H 146.04422 L 11.243246,179.79758 11.79774,191.04082 c 1.108987,18.52245 14.475826,31.93648 33.13985,33.12806 z M 641.26613,32.903927 a 112.34987,112.34987 0 0 1 0,158.903753 112.43246,112.43246 0 0 1 -158.93914,0 c -43.8758,-43.8758 -43.8758,-115.027963 0,-158.903753 A 112.29089,112.29089 0 0 1 561.72577,2.7082708e-5 112.37347,112.37347 0 0 1 641.26613,32.915727 Z m -31.7949,31.8185 a 67.447677,67.447677 0 0 1 0,95.349333 67.447677,67.447677 0 0 1 -95.34934,0 67.447677,67.447677 0 0 1 0,-95.349333 67.447677,67.447677 0 0 1 95.34934,0 z M 325.91256,2.7082708e-5 A 112.29089,112.29089 0 0 1 405.31134,32.915727 c 43.88759,43.86399 43.88759,115.027953 0,158.891953 a 112.43246,112.43246 0 0 1 -158.93914,0 c -43.8758,-43.8758 -43.8758,-115.027963 0,-158.903753 A 112.29089,112.29089 0 0 1 325.77098,2.7082708e-5 Z M 373.51643,64.698837 a 67.447677,67.447677 0 0 1 0,95.361123 67.447677,67.447677 0 0 1 -95.34933,0 67.447677,67.447677 0 0 1 0,-95.349333 67.447677,67.447677 0 0 1 95.34933,0 z",
      style: {"fill":"#2d8cff","fill-rule":"evenodd","stroke-width":"11.79773998"}
    }, null, -1))
  ]))
}
export default { render: render }